import { render, staticRenderFns } from "./ProjectWorkAssignments.vue?vue&type=template&id=44054f51"
import script from "./ProjectWorkAssignments.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectWorkAssignments.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports